import { useContext } from 'react';

import { Button, Text } from '@chakra-ui/react';

import { PaperworkType } from '../../../../gql/generated/graphql';

import Modal from '../../../shared/Modal';

import { DealContext } from '../../../../libs/DealContext';

type SelectSigningModalProps = {
  handleMarkAsSent: (signingOnCom: boolean) => void;
  isOpen: boolean;
  onClose: () => void;
};

const SelectSigningModal = ({ handleMarkAsSent, isOpen, onClose }: SelectSigningModalProps) => {
  const {
    deal: { customer, cobuyer, paperwork_type },
  } = useContext(DealContext);

  const isRouteOne = paperwork_type === PaperworkType.RouteOne;

  return (
    <Modal
      title="Send for Signatures"
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      closeOnOverlayClick={false}
      size="2xl"
      showDivider={false}
      rightButtons={
        <Button
          variant={isRouteOne ? 'secondary' : 'primary'}
          onClick={() => {
            handleMarkAsSent(!isRouteOne);
            onClose();
          }}
        >
          Sign On {isRouteOne ? 'ROUTE ONE' : 'LEASEEND.COM'}
        </Button>
      }
      leftButtons={
        <Button variant="warning" onClick={onClose}>
          Cancel
        </Button>
      }
    >
      <Text mb={4} fontWeight="normal">
        Please verify the email(s) below with the customer(s) and ensure your contracts are fully
        prepared for signing.
      </Text>
      {isRouteOne && (
        <Text mb={4} fontWeight="normal">
          Ensure all contracts are validated and generated. To sign, trigger e-remote signing email
          in Route One.
        </Text>
      )}
      <Text marginX="50px" display="flex">
        <Text fontWeight="bold" w="20%">
          • Buyer:
        </Text>
        <Text justifySelf="end" fontWeight="normal">
          {customer.email}
        </Text>
      </Text>
      {cobuyer && (
        <Text marginX="50px" display="flex">
          <Text fontWeight="bold" w="20%">
            • CoBuyer:
          </Text>
          <Text justifySelf="end" fontWeight="normal">
            {cobuyer.email}
          </Text>
        </Text>
      )}
    </Modal>
  );
};

export default SelectSigningModal;
